export const SET_MAKES_DATA = '[MAKES] SET_MAKES_DATA';

export const setMakesData = (data) => ({
  type: SET_MAKES_DATA,
  payload: data,
});
